import React from "react"
import styled from "styled-components"
import { ReactComponent as ArrowRight } from "images/icons/arrows-left-right.svg"
import { ReactComponent as CalendarIcon } from "images/icons/calendar.svg"
import Input from "../Ui/Form/Input"
import { IconWrapper } from "./OrderChart.styled"

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  div {
    padding: 1px;
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;

  svg {
    width: 2.8rem;
    height: 2.8rem;
    margin-right: 0;
  }

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    flex-direction: row;
    gap: 1.5rem;
  }
`

type Props = {
  setFromDate: (e: string) => void
  setToDate: (e: string) => void
  defaultFromDate: string
  defaultToDate: string
  type?: string
}
const FilterSectionDashboard = (
  {
    setFromDate,
    setToDate,
    defaultFromDate,
    defaultToDate,
    type = "datetime-local"
  }: Props) => {
  const minDate = "2025-02-01T00:00"

  return (
    <Container>
      <IconWrapper>
        <CalendarIcon />
      </IconWrapper>
      <Wrapper>
        <Input
          min={minDate}
          max={defaultToDate || undefined}
          value={defaultFromDate}
          type={type}
          name="fromDate"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFromDate(e.target.value)}
        />
        <ArrowRight />
        <Input
          min={defaultFromDate || minDate}
          value={defaultToDate}
          type={type}
          name="toDate"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setToDate(e.target.value)}
        />
      </Wrapper>
    </Container>
  )
}

export default FilterSectionDashboard
